import React from 'react';
import classnames from 'classnames';

const FeatherIcon = (props) => {
  const { position = 'left', rank = 1 } = props;
  const fill =
    rank == 1
      ? '#D69500'
      : rank == 2
        ? '#76777B'
        : rank == 3
          ? '#E67A45'
          : '#FF6079';
  return position == 'left' ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 12 32"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M5.75051 6.98429L5.71727 6.92383C5.40977 7.54787 5.06535 8.15323 4.83499 8.80597C4.70385 9.17754 4.52449 9.54327 4.39452 9.91341C2.94381 14.1144 3.00145 18.6583 4.55827 22.8244C5.56662 25.5215 7.17796 27.976 9.27995 30.0166C9.96054 30.6811 10.7523 31.4209 11.5611 31.936C11.9147 32.1612 12.2792 31.7536 11.6715 31.309C9.70058 29.868 7.91604 28.0079 6.62445 25.9756C3.9102 21.7152 2.97615 16.6326 4.00884 11.7425C4.32897 10.2851 4.86236 8.77828 5.52716 7.43209C5.59502 7.29467 5.6732 7.1132 5.75051 6.98429Z"
        fill={fill}
      />
      <path
        d="M5.97713 0.658203C5.60504 0.960536 5.02883 1.96847 4.86578 2.40916C4.47728 3.45923 4.40275 5.00834 5.45145 5.73964C5.53056 5.7845 5.60773 5.83247 5.68272 5.88343C6.51786 4.47002 7.35497 1.99147 5.97713 0.658203Z"
        fill={fill}
      />
      <path
        d="M3.64537 26.2399C3.21621 26.2092 2.94453 26.2675 2.53532 26.4089C2.85499 27.0116 3.28876 27.5523 3.81461 28.0037C4.49363 28.5976 5.44787 29.034 6.38334 28.9938C6.84218 28.9405 7.14993 28.8469 7.50308 28.5603C7.48786 28.5418 7.47246 28.5236 7.45688 28.5055C6.71014 27.6355 5.63197 26.7466 4.495 26.3868C4.22486 26.3013 3.92811 26.2663 3.64537 26.2399Z"
        fill={fill}
      />
      <path
        d="M1.42918 22.1033C1.20378 22.0933 1.03809 22.0996 0.816067 22.12C0.951034 22.9267 1.73585 24.1073 2.41198 24.6115C3.08558 25.1138 3.66631 25.3864 4.52755 25.322C4.75895 25.2933 4.9713 25.2064 5.17886 25.1103C4.54232 23.8468 3.16638 22.2577 1.60143 22.1147C1.54541 22.1097 1.48542 22.1066 1.42918 22.1033Z"
        fill={fill}
      />
      <path
        d="M1.17298 8.70776C1.13038 8.72065 1.12225 8.75698 1.11073 8.79257C0.569888 10.4642 0.822147 12.8171 2.8366 13.4565C2.87865 13.4672 3.02683 13.4848 3.07752 13.4921C3.17831 12.2021 3.15479 11.0795 2.51059 9.89458C2.24827 9.41206 1.73033 8.87095 1.17298 8.70776Z"
        fill={fill}
      />
      <path
        d="M3.10451 4.48779L3.08521 4.49931C2.46592 5.56983 2.19263 6.77543 2.49918 7.99217C2.64304 8.5632 3.11619 9.1933 3.65716 9.49146C3.74966 9.5335 3.86002 9.56181 3.95879 9.59056C4.35991 8.24024 4.59224 6.70803 3.93063 5.38558C3.73091 4.98636 3.46565 4.75121 3.10451 4.48779Z"
        fill={fill}
      />
      <path
        d="M0.292852 17.6512L-1.86549e-07 17.6401C0.122939 18.8919 0.563071 19.9693 1.56341 20.8288C2.01498 21.2168 2.68945 21.4568 3.29673 21.4239C3.43781 21.4113 3.53668 21.3868 3.67496 21.3549C3.44547 20.488 3.03234 19.6753 2.46112 18.9671C1.91605 18.3029 1.19272 17.7552 0.292852 17.6512Z"
        fill={fill}
      />
      <path
        d="M0.149135 13.1216L0.114839 13.1288C0.0772729 13.1775 0.0839374 13.2857 0.0795286 13.3486C-0.0164906 14.7217 0.382113 16.2023 1.57018 17.0733C1.96417 17.3623 2.37184 17.4407 2.86199 17.4343L2.92459 17.4219C2.92953 17.4153 2.94491 17.3918 2.94448 17.3848C2.85171 15.8186 1.9799 13.4608 0.149135 13.1216Z"
        fill={fill}
      />
      <path
        d="M11.966 4.18655e-05C11.1603 -0.00493194 10.1055 0.434026 9.48016 0.916077C8.63393 1.5684 7.99353 2.34729 7.70868 3.36633C7.63887 3.61609 7.61311 3.84594 7.5814 4.09906C7.59399 4.09484 7.60653 4.09053 7.61904 4.08614C9.02603 3.5927 10.3784 2.59965 11.202 1.39927C11.5006 0.964027 11.7373 0.471582 11.966 4.18655e-05Z"
        fill={fill}
      />
      <path
        d="M9.89356 4.57671C9.73366 4.55996 9.4695 4.57904 9.30913 4.60018C8.33543 4.72849 7.66175 5.19805 7.04586 5.90574C6.89978 6.07361 6.77966 6.25263 6.64303 6.42648C7.01898 6.62362 7.56575 6.72411 7.99179 6.73176C9.3722 6.7135 10.3598 6.01037 11.2843 5.12948C10.8587 4.78998 10.4511 4.62274 9.89356 4.57671Z"
        fill={fill}
      />
      <path
        d="M8.83159 23.3413C8.67191 23.4453 8.51962 23.5251 8.366 23.6395C7.9636 23.9397 7.67897 24.4571 7.5655 24.9275C7.31395 25.9702 7.658 26.8438 8.22122 27.7101L8.3569 27.9065C9.42249 27.0697 9.55382 25.5486 9.21881 24.3491C9.12491 24.0128 8.97086 23.6636 8.83159 23.3413Z"
        fill={fill}
      />
      <path
        d="M8.20014 7.52933C7.77565 7.47005 7.14635 7.65486 6.78021 7.84622C5.90875 8.30173 5.33221 9.06188 5.03389 9.94909C5.41053 10.0261 5.61725 10.0327 5.99073 10.0132C6.06344 10.0083 6.13599 10.0014 6.20828 9.99253C7.19058 9.87553 8.09392 9.25437 8.71297 8.5352C8.8944 8.32442 9.05513 8.06555 9.23746 7.84227C8.92721 7.64043 8.56632 7.56803 8.20014 7.52933Z"
        fill={fill}
      />
      <path
        d="M7.31303 10.696C6.68498 10.6235 6.01559 10.8462 5.5267 11.2153C4.73821 11.8105 4.31657 12.6738 4.18489 13.6045C4.35432 13.6072 4.53207 13.602 4.70211 13.5996C4.98029 13.5784 5.25321 13.5155 5.51089 13.4131C5.9534 13.2398 6.31858 12.9576 6.66623 12.6514C7.2371 12.1486 7.56253 11.5035 7.8566 10.8334C7.64961 10.7404 7.54119 10.7245 7.31303 10.696Z"
        fill={fill}
      />
      <path
        d="M7.04116 17.1865C6.95077 17.1924 6.86074 17.2028 6.77147 17.2176C5.14435 17.4846 4.45809 19.1735 4.66512 20.5951C4.68394 20.7243 4.70852 20.8539 4.73203 20.9825C4.73516 20.994 4.75086 21.0222 4.75718 21.0346C4.76775 21.0362 4.7957 21.0393 4.80483 21.0373C5.78275 20.8238 6.46367 19.9633 6.78476 19.0981C7.02529 18.4502 7.08352 17.8663 7.04116 17.1865Z"
        fill={fill}
      />
      <path
        d="M7.1066 13.9344C7.05593 13.9333 7.00523 13.9327 6.95456 13.9324C5.70678 13.9273 4.85811 14.5835 4.36154 15.6608C4.10239 16.2229 4.06349 16.7525 4.06143 17.3544C5.84933 17.1906 6.90676 15.5055 7.1066 13.9344Z"
        fill={fill}
      />
      <path
        d="M7.62009 20.3536C6.27745 20.5955 5.59324 22.1401 5.77642 23.3216C5.84258 23.7483 5.92862 24.0201 6.08951 24.4158L6.17383 24.6136C6.91498 24.3006 7.4438 23.4364 7.63695 22.7137C7.83171 21.9851 7.82485 21.0822 7.62009 20.3536Z"
        fill={fill}
      />
      <path
        d="M5.74695 6.9837C5.93283 6.60822 6.24265 6.16675 6.39371 5.82471C6.15715 6.1664 5.89023 6.5468 5.71371 6.92324L5.74695 6.9837Z"
        fill={fill}
      />
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%"
      viewBox="0 0 12 32"
      fill="none"
      preserveAspectRatio="none"
    >
      <path
        d="M6.24633 6.98368L6.27957 6.92322C6.58705 7.54727 6.93145 8.15265 7.16179 8.80541C7.29293 9.17699 7.47228 9.54273 7.60224 9.91288C9.05286 14.114 8.99522 18.658 7.43849 22.8242C6.43021 25.5214 4.81897 27.9759 2.7171 30.0166C2.03656 30.6811 1.24486 31.421 0.436126 31.9361C0.0824863 32.1612 -0.281982 31.7536 0.325729 31.3091C2.2965 29.868 4.08093 28.0078 5.37244 25.9755C8.08653 21.715 9.02052 16.6323 7.9879 11.7421C7.66778 10.2846 7.13442 8.77772 6.46966 7.43149C6.40181 7.29407 6.32363 7.1126 6.24633 6.98368Z"
        fill={fill}
      />
      <path
        d="M6.02395 0.658203C6.39602 0.960544 6.9722 1.9685 7.13523 2.4092C7.52372 3.45931 7.59823 5.00845 6.54961 5.73978C6.47049 5.78464 6.39333 5.83261 6.31835 5.88357C5.48326 4.47012 4.6462 1.99151 6.02395 0.658203Z"
        fill={fill}
      />
      <path
        d="M8.35162 26.2399C8.78075 26.2092 9.05241 26.2675 9.4616 26.4089C9.14195 27.0116 8.7082 27.5524 8.18238 28.0037C7.5034 28.5977 6.54922 29.0341 5.61381 28.9938C5.155 28.9406 4.84727 28.8469 4.49414 28.5604C4.50936 28.5419 4.52476 28.5236 4.54034 28.5056C5.28703 27.6355 6.36514 26.7466 7.50204 26.3868C7.77216 26.3013 8.0689 26.2663 8.35162 26.2399Z"
        fill={fill}
      />
      <path
        d="M10.5678 22.1037C10.7932 22.0938 10.9589 22.1001 11.1809 22.1205C11.0459 22.9272 10.2612 24.1079 9.58507 24.6121C8.91151 25.1143 8.33082 25.3869 7.46963 25.3226C7.23825 25.2939 7.02591 25.207 6.81836 25.1108C7.45486 23.8473 8.83072 22.2582 10.3956 22.1152C10.4516 22.1102 10.5116 22.107 10.5678 22.1037Z"
        fill={fill}
      />
      <path
        d="M10.8241 8.70776C10.8667 8.72065 10.8748 8.75698 10.8864 8.79257C11.4272 10.4642 11.1749 12.8172 9.16061 13.4566C9.11855 13.4673 8.97039 13.4849 8.9197 13.4922C8.81891 12.2021 8.84244 11.0796 9.4866 9.89461C9.7489 9.41208 10.2668 8.87095 10.8241 8.70776Z"
        fill={fill}
      />
      <path
        d="M8.89264 4.48877L8.91194 4.50029C9.53119 5.57083 9.80446 6.77647 9.49793 7.99324C9.35407 8.56429 8.88096 9.1944 8.34002 9.49257C8.24752 9.53461 8.13717 9.56292 8.03841 9.59168C7.63731 8.24131 7.405 6.70907 8.06657 5.38658C8.26628 4.98735 8.53152 4.75219 8.89264 4.48877Z"
        fill={fill}
      />
      <path
        d="M11.7042 17.6522L11.997 17.6411C11.8741 18.893 11.434 19.9703 10.4337 20.8299C9.98214 21.2179 9.30771 21.4578 8.70047 21.425C8.55939 21.4124 8.46054 21.3879 8.32227 21.356C8.55173 20.4891 8.96484 19.6763 9.53602 18.9681C10.0811 18.3039 10.8043 17.7561 11.7042 17.6522Z"
        fill={fill}
      />
      <path
        d="M11.8479 13.1216L11.8822 13.1288C11.9198 13.1775 11.9131 13.2857 11.9175 13.3486C12.0135 14.7217 11.615 16.2024 10.427 17.0734C10.033 17.3624 9.62535 17.4409 9.13523 17.4345L9.07263 17.422C9.0677 17.4154 9.05232 17.3919 9.05274 17.3849C9.14551 15.8187 10.0173 13.4608 11.8479 13.1216Z"
        fill={fill}
      />
      <path
        d="M0.03125 4.18667e-05C0.836839 -0.00493207 1.8916 0.434037 2.51691 0.916101C3.36309 1.56844 4.00345 2.34735 4.28828 3.36642C4.35808 3.61619 4.38384 3.84604 4.41556 4.09917C4.40296 4.09495 4.39043 4.09064 4.37791 4.08625C2.97101 3.5928 1.61876 2.59972 0.795192 1.39931C0.496567 0.964053 0.259906 0.471594 0.03125 4.18667e-05Z"
        fill={fill}
      />
      <path
        d="M2.10358 4.57671C2.26347 4.55996 2.52761 4.57904 2.68797 4.60018C3.66161 4.72849 4.33525 5.19806 4.95111 5.90578C5.09718 6.07365 5.21729 6.25267 5.35391 6.42653C4.97798 6.62368 4.43124 6.72417 4.00524 6.73182C2.62491 6.71356 1.63737 6.01041 0.712891 5.1295C1.13845 4.78999 1.54603 4.62274 2.10358 4.57671Z"
        fill={fill}
      />
      <path
        d="M3.15974 23.3428C3.3194 23.4467 3.47169 23.5266 3.6253 23.641C4.02768 23.9412 4.31229 24.4586 4.42575 24.929C4.67728 25.9718 4.33325 26.8453 3.77007 27.7117L3.6344 27.9081C2.56887 27.0713 2.43755 25.5502 2.77254 24.3506C2.86644 24.0143 3.02048 23.6651 3.15974 23.3428Z"
        fill={fill}
      />
      <path
        d="M3.79702 7.52933C4.22148 7.47005 4.85075 7.65487 5.21686 7.84623C6.08827 8.30175 6.66478 9.06193 6.96308 9.94915C6.58646 10.0262 6.37975 10.0328 6.0063 10.0133C5.93359 10.0084 5.86104 10.0015 5.78875 9.99259C4.80652 9.87559 3.90323 9.25441 3.28422 8.53523C3.1028 8.32444 2.94208 8.06556 2.75977 7.84228C3.06999 7.64043 3.43086 7.56804 3.79702 7.52933Z"
        fill={fill}
      />
      <path
        d="M4.6783 10.6958C5.30631 10.6233 5.97566 10.8459 6.46452 11.215C7.25296 11.8103 7.67458 12.6736 7.80625 13.6043C7.63683 13.607 7.45909 13.6019 7.28906 13.5995C7.0109 13.5783 6.73799 13.5153 6.48033 13.4129C6.03784 13.2396 5.67268 12.9574 5.32506 12.6512C4.75422 12.1484 4.42882 11.5032 4.13477 10.8332C4.34174 10.7402 4.45015 10.7243 4.6783 10.6958Z"
        fill={fill}
      />
      <path
        d="M4.95606 17.186C5.04644 17.1919 5.13647 17.2024 5.22573 17.2171C6.85276 17.4841 7.53897 19.1731 7.33195 20.5947C7.31314 20.7239 7.28856 20.8535 7.26505 20.9822C7.26192 20.9936 7.24622 21.0218 7.2399 21.0342C7.22933 21.0358 7.20138 21.0389 7.19226 21.0369C6.21439 20.8234 5.53352 19.9629 5.21245 19.0977C4.97193 18.4497 4.9137 17.8659 4.95606 17.186Z"
        fill={fill}
      />
      <path
        d="M4.88477 13.9352C4.93543 13.934 4.98612 13.9334 5.03679 13.9331C6.2845 13.9281 7.13311 14.5843 7.62966 15.6616C7.88879 16.2236 7.92769 16.7533 7.92974 17.3552C6.14196 17.1914 5.08459 15.5063 4.88477 13.9352Z"
        fill={fill}
      />
      <path
        d="M4.37126 20.3535C5.71382 20.5954 6.39798 22.1401 6.21482 23.3216C6.14867 23.7482 6.06263 24.02 5.90175 24.4158L5.81744 24.6136C5.07633 24.3006 4.54755 23.4364 4.3544 22.7136C4.15965 21.985 4.16652 21.0821 4.37126 20.3535Z"
        fill={fill}
      />
      <path
        d="M6.24633 6.98373C6.06046 6.60824 5.75066 6.16676 5.59961 5.82471C5.83615 6.16641 6.10306 6.54682 6.27956 6.92327L6.24633 6.98373Z"
        fill={fill}
      />
    </svg>
  );
};

const MonthlyRankingBadge = (props) => {
  const {
    size = 'l',
    rank = 1,
    year = '',
    month = '',
    category = '',
    categoryId = null,
  } = props;
  // const size = 'l'; // s, m, l

  const textColor = '#4A4A4A';
  const textSize = size === 's' ? 9 : size === 'm' ? 11 : 16;
  const featherSize = size === 's' ? 7 : size === 'm' ? 9 : 12;

  const date = `${year}年${month}月`;
  const text =
    size === 'l' ? `${date} ${category}類第${rank}位` : `${date}月榜`;

  const href = categoryId ? `/monthlyRanking?category=${categoryId}` : null;

  // const scale = size === 's' ? 18 / 32 : size === 'm' ? 24 / 32 : 1; // prototype
  const content = (
    <div
      className={classnames(
        'relative flex items-center',
        href && 'cursor-pointer'
      )}
    >
      <div
        style={{ width: `${featherSize}px` }}
        className="relative aspect-[12/32] shrink-0"
      >
        <FeatherIcon position="left" rank={rank} />
      </div>
      <div className="shrink-0 py-1">
        <p
          style={{
            color: textColor,
            fontSize: `${textSize}px`,
          }}
          className="font-medium leading-none"
        >
          {text}
        </p>
      </div>
      <div
        style={{ width: `${featherSize}px` }}
        className="relative aspect-[12/32] shrink-0"
      >
        <FeatherIcon position="right" rank={rank} />
      </div>
    </div>
  );

  if (href) {
    return (
      <a href={href} onClick={(e) => e.stopPropagation()}>
        {content}
      </a>
    );
  }
  return content;
};

export default MonthlyRankingBadge;
